import ParseModel from './ParseModel.mjs'
import Parse from 'parse'

export default {
  install: (Vue, options = {}) => {
    const name = options.name || 'vueParse'

    var parseModel = new ParseModel(Parse, options.appId, options.serverUrl)

    Vue[name] = parseModel
    Vue.prototype[`$${name}`] = parseModel
  }
}



//////////////////
// WEBPACK FOOTER
// ./parse-model/vuePlugin.js
// module id = DDhF
// module chunks = 0